import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-audit-activity-overview',
  templateUrl: './audit-activity-overview.component.html',
  styleUrls: ['./audit-activity-overview.component.css'],

})
export class AuditActivityOverviewComponent {
  filter!: { name: string; code: string; }[];
  days!: { name: string }[];

  @Input() databaseName: string = '';
  @Input() totalAuditEvents: number = 0;
  @Input() totalInsertions: number = 0;
  @Input() totalUpdates: number = 0;
  @Input() totalDeletions: number = 0;

  previousData: any;
  percentageChanges: any = {};
  totalChanges: any = {};

  ngOnInit() {
    this.filter = [
      { name: 'Filter option', code: 'id here to send backend/filter by' },
      { name: 'option-2', code: 'id here to send backend/filter by' },
      { name: 'option-3', code: 'id here to send backend/filter by' }
    ];
    this.days = [
      { name: 'Last 7 days' },
      { name: 'Previous day' },
      { name: 'Previous Month' }
    ];
  }

  calculateTotalChanges() {
    this.totalChanges = {
      totalAudits: this.totalAuditEvents - this.previousData.totalAudits,
      totalInserts: this.totalInsertions - this.previousData.totalInserts,
      totalUpdates: this.totalUpdates - this.previousData.totalUpdates,
      totalDeletes: this.totalDeletions - this.previousData.totalDeletes
    };
  }

  calculatePercentageChanges() {
    this.percentageChanges.totalAudits = this.calculateChange(this.previousData.totalAudits, this.totalAuditEvents, 'TotalAudits');
    this.percentageChanges.totalInserts = this.calculateChange(this.previousData.totalInserts, this.totalInsertions, 'TotalInserts');
    this.percentageChanges.totalUpdates = this.calculateChange(this.previousData.totalUpdates, this.totalUpdates, 'TotalUpdates');
    this.percentageChanges.totalDeletes = this.calculateChange(this.previousData.totalDeletes, this.totalDeletions, 'TotalDeletes');
  }

  calculateChange(previous: number, current: number, eventType: string): number {
    const previousNumber = Number(previous);
    const currentNumber = Number(current);

    if (isNaN(previousNumber) || isNaN(currentNumber)) {
      return 0;
    }

    if (previousNumber == null || previousNumber === 0) {
      if (currentNumber === 0) {
        return 0;
      } else {
        // Capture the first write to localStorage
        this.persistToLocalStorage(eventType, currentNumber);

        return 100; // Assuming 100% change if there's no previous data
      }
    }

    // set the new value here to localStorage
    //debugger;
    if (currentNumber === 0) {
      this.persistToLocalStorage(eventType, previousNumber);
    } else {
      this.persistToLocalStorage(eventType, currentNumber);
    }

    if (currentNumber === 0) {
      return 0;
    }

    return ((currentNumber - previousNumber) / previousNumber) * 100;
  }

  private persistToLocalStorage(eventType: string, currentNumber: number) {
    switch (eventType) {
      case 'TotalAudits':
        localStorage.setItem(`ssk_${this.databaseName}_totalAuditEvents`, currentNumber.toString());
        break;
      case 'TotalInserts':
        localStorage.setItem(`ssk_${this.databaseName}_totalInsertions`, currentNumber.toString());
        break;
      case 'TotalUpdates':
        localStorage.setItem(`ssk_${this.databaseName}_totalUpdates`, currentNumber.toString());
        break;
      case 'TotalDeletes':
        localStorage.setItem(`ssk_${this.databaseName}_totalDeletions`, currentNumber.toString());
        break;
    }
  }

  refreshAuditOverview() {
    window.location.reload();
  }

  ngOnChanges() {
    var localStorageTotalAuditEvents = localStorage.getItem(`ssk_${this.databaseName}_totalAuditEvents`);
    var localStorageTotalInsertions = localStorage.getItem(`ssk_${this.databaseName}_totalInsertions`);
    var localStorageTotalUpdates = localStorage.getItem(`ssk_${this.databaseName}_totalUpdates`);
    var localStorageTotalDeletions = localStorage.getItem(`ssk_${this.databaseName}_totalDeletions`);

    this.previousData = {
      totalAudits: localStorageTotalAuditEvents ? parseInt(localStorageTotalAuditEvents) : 0,
      totalInserts: localStorageTotalInsertions ? parseInt(localStorageTotalInsertions) : 0,
      totalUpdates: localStorageTotalUpdates ? parseInt(localStorageTotalUpdates) : 0,
      totalDeletes: localStorageTotalDeletions ? parseInt(localStorageTotalDeletions) : 0
    };

    this.calculateTotalChanges();
    this.calculatePercentageChanges();

    //localStorage.setItem(`ssk_${this.tableName}_totalAuditEvents`, this.totalAuditEvents.toString());
    //localStorage.setItem(`ssk_${this.tableName}_totalInsertions`, this.totalInsertions.toString());
    //localStorage.setItem(`ssk_${this.tableName}_totalUpdates`, this.totalUpdates.toString());
    //localStorage.setItem(`ssk_${this.tableName}_totalDeletions`, this.totalDeletions.toString());
  }

}
